<template>
  <div v-bind="$attrs" class="rounded-3xl border border-line">
    <div class="p-24">
      <div class="mb-16 flex items-center justify-between">
        <div class="flex items-center gap-x-8">
          <JIcon :name="icon" class="text-primary" size="32" />

          <span class="text-pane-header font-semi-bold capitalize text-primary">
            {{ $te(`book.${type}`) ? $t(`book.${type}`) : type }}
          </span>
        </div>

        <JButton
          v-if="removable"
          icon="trash-bin"
          color="danger"
          variant="tonal"
          size="xs"
          class="rounded-full"
          @click.stop="isDialogOpen = true"
        />
      </div>

      <slot />
    </div>

    <div
      class="flex items-center justify-between border-t border-line px-24 py-12"
    >
      <span class="text-pane-header font-medium">{{ $t('totalPrice') }}</span>
      <span class="text-pane-header font-bold">
        {{ price }}
      </span>
    </div>
  </div>

  <JConfirmation
    v-model="isDialogOpen"
    :title="$t('search.areYouSureYouWantToRemoveThisItem')"
    color="danger"
    :confirmText="$t('words.remove')"
    :cancelText="$t('words.cancel')"
    @confirm="onConfirm"
    @cancel="isDialogOpen = false"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { type IconsName, JButton, JConfirmation, JIcon } from '@journey/ui-kit'
import type { Emits, Props } from './ItinerarySummaryCard.types'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<Props>(), {
  removable: false,
})

const emit = defineEmits<Emits>()

const icon = computed(() => {
  const icons: { [key in Props['type']]: IconsName } = {
    flight: 'airplane-circle',
    hotel: 'building-circle',
    car: 'car-circle',
  }

  return icons[props.type]
})

const isDialogOpen = ref(false)

function onConfirm() {
  emit('delete')
  isDialogOpen.value = false
}
</script>
